import { Component, OnInit } from '@angular/core';
import { GlobalStoreService } from '../../../services/global-store/global-store.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { FormGroup } from '@angular/forms';
import { GabaritService } from 'src/app/services/gabarit/gabarit.service';
import { ParticulierBancaire } from 'src/app/api/model/particulier-bancaire.model';
import { GestionTitreService } from 'src/app/services/navigation/gestion-titre.service';
import { FormulaireCoordonneesBancaires } from 'src/app/models/formulaire/formulaire-coordonnees-bancaires.model';
import { FormulaireBancaireService } from 'src/app/services/formulaire-bancaire/formulaire-bancaire.service';
import { FormulaireBancaireBuilder } from 'src/app/models/formulaire/formulaire-bancaire-builder.model';
import { Anys } from 'src/app/util/anys';
import { AdressePhysiqueBancaire } from 'src/app/api/model/adresse-physique-bancaire.model';

@Component({
  selector: 'app-modification-coordonnees',
  templateUrl: './modification-coordonnees.component.html',
  standalone: false,
})
export class ModificationCoordonneesComponent implements OnInit {
  coordonneesMembre?: ParticulierBancaire;
  adresseCourante: AdressePhysiqueBancaire;
  formBancaire: FormGroup<FormulaireCoordonneesBancaires>;
  isAppMobile: boolean;
  codeErreur: string = '';

  constructor(
    private readonly globalStoreService: GlobalStoreService,
    private readonly navigationService: NavigationService,
    private readonly gabaritService: GabaritService,
    private readonly gestionTitreService: GestionTitreService,
    private readonly formulaireBancaireService: FormulaireBancaireService
  ) {}

  ngOnInit(): void {
    this.gestionTitreService.addTitreOnglet('caad.titreOnglet.page-modification');
    this.isAppMobile = this.gabaritService.isAppMobile();

    if (Anys.notNullOrUndef(this.formulaireBancaireService.getForm())) {
      this.formBancaire = this.formulaireBancaireService.getForm();
      this.initAdresseCourante();
    } else {
      this.globalStoreService.getCoordonneesMembre$().subscribe((membre) => {
        if (membre) {
          this.coordonneesMembre = membre;
          this.formBancaire = FormulaireBancaireBuilder.build();
          this.initAdresseCourante();

          const courriel = this.coordonneesMembre?.courriel?.adresseCourriel || '';
          this.formBancaire.patchValue({ courriel });
          if (courriel && this.formBancaire.controls.courriel.invalid) {
            this.formBancaire.patchValue({ courriel: '' });
          }
        }
      });
    }
  }

  annulerModification(): void {
    this.globalStoreService.saveEtatAfficherModaleAnnuler(true);
  }

  naviguerVersPageValidation(): void {
    const utiliserMemeAdresse = this.formBancaire.get('utiliserMemeAdresse')?.value === true;
    if (this.formBancaire.valid || utiliserMemeAdresse) {
      this.formulaireBancaireService.setForm(this.formBancaire);
      this.navigationService.naviguerVersValiderCoordonnees();
    }
  }

  public initAdresseCourante(): void {
    this.globalStoreService.getCoordonneesMembre$().subscribe((membre) => {
      this.adresseCourante = membre?.adresseCourante;
    });
  }
}
